<template>
  <!-- Mesmo padrao da aba de posicoes: a rota e uma so, a tela muda com o
       produto. As analises de ETF (CVaR por fator, backtest) nao dizem nada
       sobre uma carteira de forwards. -->
  <ndf-analytics v-if="portfolioStore.isNdf" />
  <portfolio-analytics v-else />
</template>

<script>
import { mapStores } from 'pinia'
import { usePortfolioStore } from '@/store/portfolioStore.js'
import PortfolioAnalytics from './PortfolioAnalytics.vue'
import NdfAnalytics from './NdfAnalytics.vue'

export default {
  name: 'AnalyticsTab',
  components: { PortfolioAnalytics, NdfAnalytics },
  computed: {
    ...mapStores(usePortfolioStore),
  },
}
</script>
